<template>
  <div>
    <b-modal
      size="lg"
      id="update-item"
      title="EDITAR ITEM"
      hide-footer
      no-close-on-backdrop
    >
      <div class="filter-group">
        <label class="filter-label">
          <i class="fas fa-list-ol filter-icon"></i>
          Quantidade
        </label>

        <v-text-field
          v-model="buy_item.quantity"
          label="Quantidade"
          type="number"
          outlined
          dense
          hide-details
          class="modern-input"
          min="1"
          step="1"
        />
      </div>

      <ErrorsMessages :errors="errors" />

      <div class="btn-modal-wrapper">
        <v-btn :disabled="loading" class="btn-save-modern" @click="update">
          <i class="fas fa-edit mr-2"></i>
          {{ loading ? "Salvando..." : "Editar Item" }}
        </v-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";

import toast from "../../lib/ToastNotification";

import api from "../../services/api";

export default {
  components: {
    ErrorsMessages,
  },

  props: {
    buy_item_id: [String, Number],
  },

  data() {
    return {
      loading: false,

      buy_item: [],

      errors: [],
    };
  },

  watch: {
    buy_item_id() {
      this.getBuyItem();
    },
  },

  async mounted() {
    await this.getBuyItem();
  },

  methods: {
    async getBuyItem() {
      try {
        this.loading = true;

        const { buy_item_id } = this;

        let params = { buy_item_id };

        const response = await api.get("/buy-item", {
          params,
        });

        const { buy_item } = response.data;

        this.buy_item = buy_item;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async update() {
      try {
        this.loading = true;

        const id = this.buy_item.id;
        const quantity = this.buy_item.quantity;

        let params = {
          id,
          quantity,
        };

        const response = await api.put("/buy-item", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$emit("update");

          this.$bvModal.hide("update-item");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.btn-modal-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>